



















// @ is an alias to /src
import Vue from 'vue';
import SideBar from '@/components/SideBar/index.vue';

export default Vue.extend({
  name: 'About',
  components: {
    SideBar
  },
  computed: {
    drawer: {
      get(): string {
        return (this as any).$store.state.drawer;
      },
      set(value: boolean) {
        (this as any).$store.dispatch('setDrawer', value);
      }
    }
  },
  methods: {
    routeTo(navigation: string) {
      this.$router.push({ path: navigation });
    }
  }
});
